/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_WaitingInputs */

const en_us2_coach_waiting = /** @type {(inputs: Coach_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your trainer is still writing. The answer appears here as soon as it is ready.`)
};

const pt_br2_coach_waiting = /** @type {(inputs: Coach_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O personal ainda está escrevendo. A resposta aparece aqui assim que ficar pronta.`)
};

const es_419_coach_waiting = /** @type {(inputs: Coach_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu entrenador sigue escribiendo. La respuesta aparece aquí en cuanto esté lista.`)
};

const pt_pt2_coach_waiting = /** @type {(inputs: Coach_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O treinador ainda está a escrever. A resposta aparece aqui assim que estiver pronta.`)
};

const fr_fr2_coach_waiting = /** @type {(inputs: Coach_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton coach écrit encore. La réponse s'affichera ici dès qu'elle sera prête.`)
};

const de_de2_coach_waiting = /** @type {(inputs: Coach_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Coach schreibt noch. Die Antwort erscheint hier, sobald sie fertig ist.`)
};

const it_it2_coach_waiting = /** @type {(inputs: Coach_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il coach sta ancora scrivendo. La risposta compare qui appena è pronta.`)
};

/**
* | output |
* | --- |
* | "Your trainer is still writing. The answer appears here as soon as it is ready." |
*
* @param {Coach_WaitingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_waiting = /** @type {((inputs?: Coach_WaitingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_WaitingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_waiting(inputs)
	if (locale === "es-419") return es_419_coach_waiting(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_waiting(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_waiting(inputs)
	if (locale === "de-DE") return de_de2_coach_waiting(inputs)
	if (locale === "it-IT") return it_it2_coach_waiting(inputs)
	return en_us2_coach_waiting(inputs)
});
export { coach_waiting as "coach.waiting" }